export default "__VITE_ASSET__DFAldUe6__"